import 'babel-polyfill'
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons, BIcon } from 'bootstrap-vue'
import VueTouch from 'vue-touch'
import Trend from 'vuetrend'
import { sync } from 'vuex-router-sync'
import App from './App'
import layoutMixin from './mixins/layout'
import Widget from './components/widget/Widget'
import LiquorTree from 'liquor-tree'

import router from './router'
import store from './store'
import './filters'
import VueClipboard from 'vue-clipboard2'

import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VeeValidatePlugin from './plugins/vee-validate'
import PortalVue from 'portal-vue'
import directives from './directives'

// global registration
Vue.use(LiquorTree)

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueTouch)
Vue.use(Trend)
Vue.component('Widget', Widget)
Vue.component('BIcon', BIcon)
Vue.mixin(layoutMixin)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.use(VueLodash, { lodash: lodash })
Vue.use(VeeValidatePlugin, {})
Vue.use(PortalVue)

// 커스텀 디렉티브 등록
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key])
})

sync(store, router)

function bootstrap() {
  return new Vue({
    el: '#wrap',
    router,
    store,
    render: h => h(App)
  })
}

bootstrap()
